import Cookies from "js-cookie";
import axios from "axios";
import AuthService from "@/services/resources/AuthService";
import ResetPassword from "@/services/resources/ResetPassword";
import CheckUser from "@/services/resources/CheckUser";
import ValidatePurchase from "@/services/resources/ValidatePurchase";
import CreatePassword from "@/services/resources/CreatePassword";
import router from "@/router/index";
import SiteService from "@/services/resources/SiteService";
import { func } from '@/services/libs/convertColor';

export default {
  //fazer login do OAuth 2
  loginRequest({ state }, captcha) {
    const service = AuthService.build();
    return new Promise((resolve, reject) => {
      service
        .login(state.email, state.password, captcha)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          Cookies.remove('auth_greennCourse');
          reject(err);
        })
    })
  },
  resetPassword({ state }, captcha) {
    const service = ResetPassword.build();
    return new Promise((resolve, reject) => {
      service
        .reset(state.email, captcha)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        })
    })
  },
  updateUserCustomFields: function ({ commit }, payload) {
    commit('userCustomFields', true);
  },
  blogSelected(context, payload) {

    let routerIsLiberated = true;

    Cookies.remove('auth_greennCourse');
    Cookies.remove('access_level');
    Cookies.remove('userCustomFields');

    const assign = 'auth_greennCourse' + "=" + escape(payload.Auth) + ";";
    const assign2 = 'access_level' + "=" + escape(payload.role) + ";";
    const assign3 = 'userCustomFields' + "=" + escape(payload.custom_fields_filled) + ";";

    const d = new Date();

    d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString() + ";";
    const path = "path=/;";
    var domain = "";
    if (process.env.VUE_APP_TYPE === 'DEV') {
      domain = "domain=" + 'localhost' + ";";
    } else if (process.env.VUE_APP_TYPE === 'PROD' && payload.domains.length === 0 && (payload.role === 'owner' || payload.role === 'admin')) {
      domain = "domain=" + "app.greenn.club" + ";";
    } else if (process.env.VUE_APP_TYPE === 'PROD' && payload.domains.length === 0 && (payload.role === 'student')) {
      domain = "domain=" + payload.subdomain + '.greenn.club' + ";";
    } else if (process.env.VUE_APP_TYPE === 'PROD' && payload.domains.length !== 0) {
      const domains = payload.domains;
      let xxxDomains = domains.filter(function (e) {
        return e.domain === "https://" + window.location.host;
      });
      if (xxxDomains.length !== 0) {
        let domainActual = xxxDomains[0].domain;
        let replaceDomain = domainActual.replace('https://', '')
        domain = "domain=" + replaceDomain + ";";
      } else {
        domain = "domain=app.greenn.club;";
      }
    }

    localStorage.removeItem('sessionId');
    document.cookie = assign + expires + path + domain;
    document.cookie = assign2 + expires + path + domain;
    document.cookie = assign3 + expires + path + domain;


    context.commit('authSuccess', payload.Auth);
    context.commit('userCustomFields', payload.custom_fields_filled);
    context.dispatch('getMetasSite');
    context.dispatch('getCertificateConfig');

    if (process.env.VUE_APP_TYPE === 'DEV') {
      if (payload.course_id !== undefined && payload.course_id !== null) {
        // window.location.href = "http://" + window.location.host + "/curso/" + payload.course_id;
        router.push({ path: `curso/${payload.course_id}` })
      } else {
        // window.location.href = "http://" + window.location.host + "/home";
        router.push({ path: 'home' })
      }
    } else if (process.env.VUE_APP_TYPE === 'PROD' && (payload.role === 'owner' || payload.role === 'admin')) {
      var domainTo = window.location.host;
      if (domainTo.search("app.greenn.club") === -1) {
        routerIsLiberated = false;
        let auth = { payload }
        axios.post(process.env.VUE_APP_API_HOST + `/member/auth`, { auth })
          .then(function (resp) {
            // routerIsLiberated = true;
            // console.log("redirect subdomain project", resp);
            window.location.href = "https://app.greenn.club?rdr=" + resp.data.string;
            // router.go();
          })
      } else {
        if (payload.course_id !== undefined && payload.course_id !== null) {
          window.location.href = "http://app.greenn.club/curso/" + payload.course_id;
        } else {
          window.location.href = "https://app.greenn.club/home";
        }
      }
    } else if (process.env.VUE_APP_TYPE === 'PROD' && payload.domains.length === 0 && payload.role === 'student') {
      const regex = new RegExp('(greenn.club)', 'gi');
      let result = regex.exec(window.location.host);
      routerIsLiberated = false
      if (result === null || window.location.host === "app.greenn.club") {
        let auth = { payload }
        axios.post(process.env.VUE_APP_API_HOST + `/member/auth`, { auth })
          .then(function (resp) {
            // routerIsLiberated = true;
            // console.log("redirect subdomain project", resp);
            window.location.href = "https://" + payload.subdomain + ".greenn.club?rdr=" + resp.data.string;
            // router.go();
          })
          .catch(e => {
            console.log("eeee", e)
          })
      } else {
        if (payload.course_id !== undefined && payload.course_id !== null) {
          window.location.href = "https://" + payload.subdomain + ".greenn.club/curso/" + payload.course_id;
        } else {
          window.location.href = "https://" + payload.subdomain + ".greenn.club/home";
        }
      }
    } else if (process.env.VUE_APP_TYPE === 'PROD' && payload.domains.length !== 0) {
      const domains = payload.domains;
      let xxxDomains = domains.filter(function (e) {
        return e.domain === "https://" + window.location.host;
      });

      if (xxxDomains.length === 0) {
        routerIsLiberated = false;
        let auth = { payload }
        axios.post(process.env.VUE_APP_API_HOST + `/member/auth`, { auth })
          .then(function (resp) {
            // routerIsLiberated = true;
            // console.log("redirect domain project", resp);
            window.location.href = payload.domains[0].domain + "?rdr=" + resp.data.string;
            // router.go();
          })
      } else {
        if (payload.course_id !== undefined && payload.course_id !== null) {
          window.location.href = xxxDomains[0].domain + "/curso/" + payload.course_id;
        } else {
          window.location.href = xxxDomains[0].domain + "/home";
        }
      }
    }

    if (routerIsLiberated) {
      setTimeout(() => {
        router.go();
      }, 500)
    }
  },
  logoutRequest: ({ commit, dispatch }) => {
    // Since the logout process not need to make a request
    // just remove the cookies and redirect
    commit('authLogout');
    commit('userLogout');
  },
  saveEmail({ commit }, payload) {
    commit("setEmail", payload);
  },
  saveDocument({ commit }, payload) {
    commit("setDocument", payload);
  },
  savePassword({ commit }, payload) {
    commit("setPassword", payload);
  },
  saveConfirmPassword({ commit }, payload) {
    commit("setConfirmPassword", payload);
  },
  buttonIsDisabled({ commit }, payload) {
    commit("setButtonIsDisabled", payload);
  },
  createPassword({ state }) {
    const service = CreatePassword.build();
    return new Promise((resolve, reject) => {
      service
        .createPassword(state.email, state.document, state.password, state.confirmPassword)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
    })
  },
  checkUser({ state }) {
    const service = CheckUser.build();
    return new Promise((resolve, reject) => {
      service
        .checkUser(state.email)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
    })
  },
  validatePurchase({ state }) {
    const service = ValidatePurchase.build();

    return new Promise((resolve, reject) => {
      service
        .validatePurchase(state.email, state.document)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
    })
  },
  getLogobyDomain({ commit }) {
    const serviceSite = SiteService.build();

    serviceSite
      .read("/login")
      .then((resp) => {
        window.document.title = resp.site_name + " - Greenn.Club";

        if (resp.meta.free_courses === 'on') {
          commit("setFreeCourses", true);
        }

        commit("setLogo", resp.meta.logo);

        if (resp.meta.logo !== null) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.getElementsByTagName("head")[0].appendChild(link);
          }
          link.href = resp.meta.logo;
        }
        if (resp.meta.theme_fixed_painel === "on") {
          const color = resp.meta.theme_fixed_painel_color;
          document.documentElement.setAttribute("data-theme", color);
          commit("setThemeFixedPanel", true);
        }
        if (resp.meta.main_color !== null) {
          const mainColor = resp.meta.main_color;
          const convertedColor = func.convertColor(mainColor, 210);
          commit("setColor", mainColor);
          document.documentElement.setAttribute("data-color", mainColor);
          document.documentElement.style.setProperty("--maincolor", mainColor);
          document.documentElement.style.setProperty('--maincolorn', convertedColor);
          document.documentElement.style.setProperty("--maincolortrans", mainColor + "0f");
        }
        if (resp.meta.login_background_image && resp.meta.login_background_image.cdn_url) {
          commit("setBackgroundImage", true);

          var background = resp.meta.login_background_image.cdn_url;
          commit("setUrlBackground", background);
        }
      })
  },
}
